<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async
        } as data"
    >
        <ng-container *ngIf="titleKey">
            <h6 class="bazis-form__group-title">
                {{ t(titleKey, titleParams) }}
                <span
                    color="danger"
                    *ngIf="data.required && !dateTitleKey"
                >
                    *
                </span>
                <bazis-interrogation
                    *ngIf="tooltipKey"
                    iconSize="compact"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipOffset]="[-8, 4]"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                    [icon]="icons.interrogation"
                    [type]="interrogationType"
                ></bazis-interrogation>
            </h6>
        </ng-container>
        <bazis-grid
            class="bazis-grid_form"
            [style.--bazis-grid-columns]="widthForm === 'full' ? '8' : '12'"
        >
            <bazis-row class="bazis-datetime-control">
                <bazis-col
                    sizeXs="8"
                    sizeSm="4"
                >
                    <div
                        #dateInput
                        clickOutside
                        (clickOutside)="showDateCalendar = false"
                        [excludeElement]="calendarPopper"
                    >
                        <div [class]="'bazis-control ' + cssClassSizeControl">
                            <bazis-label
                                [title]="dateTitleKey ? t(dateTitleKey) : t(titleKey)"
                                [required]="data.required"
                            >
                            </bazis-label>

                            <div
                                class="bazis-control__field-group bh-pointer"
                                [class.bazis-control__field-group--disabled]="disabled"
                                (click)="openDateCalendar($event)"
                            >
                                <bazis-control-field-start
                                    *ngIf="placeIcon === 'left'"
                                    [icon]="icons.date"
                                >
                                </bazis-control-field-start>

                                <div class="bazis-control__field-wrapper">
                                    <div class="bazis-control__field">
                                        {{ dateValue.value ? dateValue.value : '' }}
                                    </div>
                                </div>

                                <bazis-control-field-end
                                    [icon]="placeIcon === 'right' ? icons.date : ''"
                                    [canEraserShow]="true"
                                    [value]="dateValue.value"
                                    (erased)="onClearDate()"
                                >
                                </bazis-control-field-end>
                            </div>

                            <div
                                *ngIf="dateValue.errors"
                                class="bazis-control__error"
                            >
                                <bazis-form-error
                                    [validationErrorMessages]="validationErrorMessages"
                                    [formControl]="dateValue"
                                ></bazis-form-error>

                                <!-- для ошибок родительского контрола
                            (пример использоавния в input-text-array, предполагается сюда "вложить" bazis-form-error) -->
                                <ng-content></ng-content>
                            </div>
                        </div>

                        <div
                            class="bh-popper-z-index"
                            #calendarPopper
                            [hidden]="!showDateCalendar"
                        >
                            <bazis-datepicker
                                *ngIf="showDateCalendar"
                                [value]="calendarDateValue"
                                (valueChange)="setValueFromDateCalendar($event)"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                [formatOutput]="displayDateFormat"
                                [marks$]="marks$"
                                [viewConfig]="datapickerViewConfig"
                            ></bazis-datepicker>
                        </div>
                    </div>
                </bazis-col>
                <bazis-col
                    sizeXs="8"
                    sizeSm="4"
                    class="bazis-input-time"
                >
                    <div #timeInput>
                        <bazis-input-default
                            #timeCalendarToggler
                            [formControl]="timeValue"
                            [maskSettings]="maskTimeSettings"
                            [rightIcon]="icons.time"
                            [isRightIconClickable]="true"
                            [titleKey]="timeTitleKey"
                            [tooltipKey]="timeTooltipKey"
                            [tooltipSettings]="tooltipTimeSettings"
                            [noteKey]="timeNoteKey"
                            [required$]="required$"
                            [validationErrorMessages]="validationErrorMessages"
                            [sizeControl]="sizeControl"
                            (rightIconClick)="openTimeCalendar($event)"
                            (touched)="markAsTouched()"
                        ></bazis-input-default>
                    </div>
                    <div
                        class="bh-popper-z-index"
                        #timePopper
                        [hidden]="!showTimeCalendar"
                        clickOutside
                        [excludeElement]="timeCalendarToggler.fieldEnd?.rightBtn"
                        (clickOutside)="showTimeCalendar = false"
                    >
                        <bazis-timepicker
                            *ngIf="showTimeCalendar"
                            [value]="calendarTimeValue"
                            (valueChange)="setValueFromTimeCalendar($event)"
                            [minTime]="minDate"
                            [maxTime]="maxDate"
                        ></bazis-timepicker>
                    </div>
                </bazis-col>
            </bazis-row>
            <bazis-row *ngIf="noteKey">
                <bazis-col size="8">
                    <div>{{ t(noteKey, noteParams) }}</div>
                </bazis-col>
            </bazis-row>
        </bazis-grid>
    </ng-container>
</ng-container>
